export default {
  path: '/machines',
  name: 'machines',
  component: () => import('../components/machine/Layout'),
  redirect: { name: 'MachineList' },
  meta: {
    breadcrumb: 'profile.machine.machines',
  },
  children: [
    {
      name: 'MachineList',
      path: '',
      component: () => import('../views/machine/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'MachineCreate',
      path: 'new',
      component: () => import('../views/machine/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'MachineUpdate',
      path: ':id/edit',
      component: () => import('../views/machine/Update'),
      meta: {
        breadcrumb: 'profile.machine.machine',
      },
    },
    {
      name: 'MachineShow',
      path: ':id',
      component: () => import('../views/machine/Show'),
      meta: {
        breadcrumb: 'profile.machine.machine',
      },
    },
    {
      name: 'Machine',
      path: ':parent',
      component: () => import('../components/producttypefile/Layout'),
      meta: {
        breadcrumb: 'qualitycheck.product.producttypefiles',
      },
      children: [
        {
          name: 'ProducttypefileMachineCreate',
          path: 'new',
          component: () => import('../views/producttypefile/Create'),
          meta: {
            breadcrumb: 'global.add',
          },
        },
      ]

    },
  ]
};
